import { withCompInfo } from '../../core/withCompInfo'
import { AudioPlayerDefinition, AudioPlayerProps } from './types'

const staticAudioUrl = 'https://music.wixstatic.com/mp3' // TODO add to topology

export const props = withCompInfo<AudioPlayerProps, AudioPlayerDefinition>(
	['compData', 'skin'],
	({ compData, skin }) => {
		return {
			skin: skin || 'SimplePlayer',
			playlist: [{ url: `${staticAudioUrl}/${compData.uri}` }],
			autoPlay: compData.autoPlay,
			loop: compData.loop,
			volume: compData.volume / 100,
			originalFileName: compData.originalFileName,
		}
	}
)
